export default {
  FIX: 'FIX',
  DYNAMIC: 'DYNAMIC'
};
